// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const tatsugiri_curly: PokeData = {
  "id": 978,
  "name": "tatsugiri-curly",
  "height": 3,
  "weight": 80,
  "base_experience": 166,
  "types": [
    PokeType.DRAGON,
    PokeType.WATER
  ],
  "api_moves": [
    "water-gun",
    "harden",
    "splash",
    "mirror-coat",
    "memento",
    "taunt",
    "helping-hand",
    "muddy-water",
    "water-pulse",
    "dragon-pulse",
    "nasty-plot",
    "soak"
  ],
  "moves": [
    "splash",
    "dragon-pulse",
    "life-dew",
    "aqua-cutter",
    "bubble-beam",
    "bubble",
    "aqua-jet",
    "liquidation",
    "scale-shot",
    "hydro-pump",
    "outrage",
    "draco-meteor",
    "rain-dance"
  ],
  "evolution_chain": {
    "id": 514,
    "item": null,
    "species": [
      {
        "name": "tatsugiri",
        "order": 952,
        "types": [
          PokeType.DRAGON,
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 106,
    "speed": 119,
    "ability_power": 175
  },
  "stat_changes": [],
  "catch_rate": 100,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
